//React
import React from "react";
import {
  Link,
} from "react-router-dom";

//Material-ui

//Part
import PartPersonalityImage from './PartPersonalityImage';
import PartStarIcon from './PartStarIcon';
//Icon

//JSON


const Card = (props) => {

	return (
		<div
      className='round12'
      style={{
        display:'inline-block',
        width: '25%',
      }}
    >
      <Link to={{ pathname: '/my/personality/relation/' + props.value.type1 + '/' + props.value.type2  + '/' }}>
        <div
          className='round12'
          style={{
            margin: '2px',
            padding: '4px',
            background: '#FFF',
            borderStyle:'solid',
            borderWidth:'1px',
            borderColor:'#E5E5E5',
          }}
        >
          <h2 align='center'>{ props.value.type2 }</h2>
          <PartPersonalityImage
            type16={props.value.type2}
            width={'100%'}
          />

          <div align='center'>
            <PartStarIcon
              count={props.value.stars}
              style={{color:'#FFBC57',width:'20%'}}
            />

          </div>
        </div>
      </Link>
		</div>
	)
}


class Comp extends React.Component {


  render() {

    return (
      <div>
      {
        this.props.relation.map((value, index) => (
          <Card
            key={index}
            value={value}
          />
        ))
      }
      </div>
    )
  }
}

export default Comp;
